import React, { useMemo } from 'react';
import { Body1, Card, File, SectionHeader, Value } from '../../blocks';
import { Grid } from '@material-ui/core';
import { currencyFormatter } from '../../formatters';
import { css } from '@emotion/react';
import { ITEM_TYPE_LABELS } from '@/constants/claims';

const ClaimsItem = ({ claim_item, claim, index }) => {
    const item = useMemo(() => {
        return claim.order?.itemsByOrderId.find((item) => item.item_id === claim_item.item_id);
    }, [claim_item, claim]);

    return (
        <>
            {claim.claim_type !== 'SERVICE_FAILURE' ? (
                <Grid item>
                    <Value>Item {index + 1}</Value>
                </Grid>
            ) : null}
            <Grid
                item
                css={css`
                    margin-top: 0.75rem;
                `}
            >
                <Value>What happened?</Value>
            </Grid>
            <Grid item>
                <Body1>{claim_item.reason}</Body1>
            </Grid>
            <Grid
                item
                css={css`
                    margin-top: 0.75rem;
                `}
            >
                <Value>Requested Amount for {ITEM_TYPE_LABELS[claim.claim_type]}</Value>
            </Grid>
            <Grid item>
                <Body1>{currencyFormatter(claim_item.amount)}</Body1>
            </Grid>
            {!!item ? (
                <>
                    <Grid item>
                        <Value>Item</Value>
                    </Grid>
                    <Grid item>
                        <Body1>{[item.sku, item.description].filter((x) => !!x).join(' / ')}</Body1>
                    </Grid>
                    <Grid item>
                        <Body1>
                            {item.weight}lbs {item.length}L {item.width}W {item.height}H
                        </Body1>
                    </Grid>
                    <Grid item>
                        <Body1>Quantity: {item.quantity}</Body1>
                    </Grid>
                </>
            ) : null}
            <Grid
                item
                css={css`
                    margin-top: 0.75rem;
                `}
            >
                <Value>Additional Details</Value>
            </Grid>
            <Grid item>
                <Body1>{claim_item.description}</Body1>
            </Grid>
            {claim_item.images?.length > 0 ? (
                <>
                    <Grid
                        item
                        css={css`
                            margin-top: 0.75rem;
                        `}
                    >
                        <Value>Pictures</Value>
                    </Grid>
                    {(claim_item.images || []).map((file) => (
                        <File key={file} file={file} />
                    ))}
                </>
            ) : null}
            {claim_item.documents?.length > 0 ? (
                <>
                    <Grid
                        item
                        css={css`
                            margin-top: 0.75rem;
                        `}
                    >
                        <Value>Documents</Value>
                    </Grid>
                    {(claim_item.documents || []).map((file) => (
                        <File key={file} file={file} />
                    ))}
                </>
            ) : null}
        </>
    );
};

const ClaimItemsCard = ({ claim }) => {
    return (
        <Card>
            <Grid
                item
                css={css`
                    margin-bottom: 1rem;
                `}
            >
                <SectionHeader>Items</SectionHeader>
            </Grid>
            {(claim.items || []).map((claim_item, idx) => (
                <ClaimsItem key={claim_item.claim_item_id} claim_item={claim_item} claim={claim} index={idx} />
            ))}
        </Card>
    );
};

export default ClaimItemsCard;
